export const accountManagement = {
    allowedMaxSize: 1,
    canEditAvatar: ['learner', 'trainer', 'manager', 'administrator'],
    concatUsernameWithFirstNameLastName: false,
    displayDialogMinorAdult: true,
    displaySubTitle: false,
    displayFilters: true,
    extentedValidation: true,
    fields: {
        minor: ['label|required', 'contact_email|required', 'password|required', 'passwordConfirm|required', 'you_are|required', 'find_us|required', 'newsletter', 'picture'],
        default: ['email|required', 'password|required', 'passwordConfirm|required', 'you_are|required', 'find_us|required', 'newsletter', 'picture']
    },
    editableFields: {
        minor: ['label|required', 'contact_email|required', 'password|required', 'passwordConfirm|required', 'you_are|required', 'find_us|required', 'newsletter', 'picture'],
        default: ['email|required', 'password|required', 'passwordConfirm|required', 'you_are|required', 'find_us|required', 'newsletter', 'picture', 'checkNotifMail']
    },
    validateEmailStrategyActivated: true,
    validateEmailStrategyMode: 'modal',// Marque Blanche new rules for validating email : no connection without validated email and toaster when follow link from email
    selfSignup: true,
    emailIncludeText: '', // exist only for mathia teacher may have a info of mail doesn't contain this text format exemple @ac-
    hideEditSSO: false, // disable edition for users from SSO
    showJoinSchool: false, // part of code to join or leave a school only ubolino for moment
    feedbackMaxFileSize: '100', // max size of file to join in feedback,
    feedbackMaxFileToSend: '3', // number max of file to join
    feedbackUseInputFieldForBug: false, // use input field instead of generating text format in msg zone,
    idSubjectToOpenBugInputs: '', // if feedbackUseInputFieldForBug true one item : bug open under input it s the id of the item
    // si le select educationalLevel est caché dans le formulaire d'inscription car l'utilisateur indique qu'il est un 'teacher'
    isEducationalLevelSelectionHiddenIfUserIsTeacher: false,
    allowedMultiplesGroups: false,//citizen code setting default value false
    useleaveGroupEvent: false,//citizen code setting default value false
    useSpecificDateForGarLicence: false,//citizen code setting default value false
    emailRequiredConditionnal: false,//citizen code setting default value false
};
